<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12>
                <template>
                    <v-card v-show="loading">
                        <v-container fluid>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <div class="loader"></div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </template>
            </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-flex xs12 v-if="!loading">
                <v-card color="grey lighten-4">
                    <v-container>
                        <v-layout wrap>
                            <v-flex xs12 lg2>
                                <v-tooltip bottom :disabled="!PARLIAMENTARIAN.PortraitNote">
                                    <template v-slot:activator="{ on }">
                                        <v-card v-on="on" class="handbook-portraitCard_center" :color="PARLIAMENTARIAN.MPorSenator[0] === 'Senator' ? $store.state.COLOUR_SENATE : $store.state.COLOUR_REPRESENTATIVES" ma-2>
                                            <Portrait v-bind:PHID="PARLIAMENTARIAN.PHID"></Portrait>
                                        </v-card>
                                    </template>
                                    <span class="handbook-portraitCard_tooltip">{{PARLIAMENTARIAN.PortraitNote}}</span>
                                </v-tooltip>

                                <br/>

                                <parliamentarian-timeline class="hidden-md-and-down" :phid="PHID" :timeline="timelineData" :loading="loadingTimeline"/>

                            </v-flex>
                            <v-flex xs12 lg10>
                                <v-card-title primary-title class="py-xs-0">
                                    <h1>{{ PARLIAMENTARIAN.DisplayName }}</h1>
                                    <button v-if="showAudioPronunciation" class="pronunciationBtn" title="Audio pronunciation" 
                                        @click="playAudioPronunciation()" ><v-icon aria-hidden="true" class="mr-1">volume_up</v-icon>
                                    </button>

                                    <audio ref="audioPronunciation" >
                                        <source :src="audioPronunciationSource" v-if="showAudioPronunciation" type="audio/mpeg">
                                    </audio>
                                </v-card-title>
                                
                                <parliamentarian-federation-timeline :phid="PHID" :timeline="timelineData" :loading="loadingTimeline"/>
                                <Biography ref="biography" :FILTERED_PARLIAMENTARIAN="PARLIAMENTARIAN" :PHID="PARLIAMENTARIAN.PHID" :STATE="PARLIAMENTARIAN.State"
                                 :Electorate="PARLIAMENTARIAN.Electorate"></Biography>
                                <parliamentarian-timeline class="hidden-lg-and-up" :phid="PHID" :timeline="timelineData" :loading="loadingTimeline"/>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center>
                            <v-card-actions>
                                <v-btn @click="$router.go(-1)" color="primary">
                                    <v-icon aria-hidden="true" class="mr-1">arrow_back</v-icon>
                                    <span class="subheading mr-2">Back</span>
                                </v-btn>
                                <v-btn @click="$router.push({ name: $store.state.STRING_PARLIAMENTARIANS })" color="primary">
                                    <v-icon aria-hidden="true" class="mr-1">person</v-icon>
                                    <span class="subheading">{{this.$store.state.STRING_PARLIAMENTARIANS}}</span>
                                </v-btn>
                                <v-btn @click="DownloadBiography" color="primary">
                                    <v-icon aria-hidden="true" :class="pdfDownloadClass">{{pdfDownloadIcon}}</v-icon>
                                    <span class="subheading">&nbsp;DOWNLOAD AS PDF</span>
                                </v-btn>
                            </v-card-actions>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>

        
        <br />
    </v-container>
</template>

<script>
    import Portrait from '@/components/Portrait.vue'
    import Biography from '@/components/Biography.vue'
    import ParliamentarianTimeline from './Parliamentarian/ParliamentarianTimeline.vue'
    import ParliamentarianFederationTimeline from './Parliamentarian/ParliamentarianFederationTimeline.vue'
    import axios from 'axios'
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {
        props: {
            PHID: {
                type: String,
                required: true,
                default: 'EZ5'
            },
        },
        components: {
            Portrait,
            Biography,
            ParliamentarianTimeline,
            ParliamentarianFederationTimeline
        },
        created() {
            this.loadParliamentarian();
            this.loadTimelineData();
        },
        data() {
            return {
                loading: true,
                pdfDownloading: false,
                loadingTimeline: true,
                timelineData: null,
                showAudioPronunciation: false
            }
        },
        computed: {
            pdfDownloadIcon(){
                return this.pdfDownloading ? 'cached' : 'picture_as_pdf';
            },
            pdfDownloadClass(){
                let pdfClass = 'mr-1';
                if (this.pdfDownloading){
                    pdfClass = pdfClass + ' loading'
                }
                return pdfClass;
            },
            audioPronunciationSource () {
                return window.location.origin + '/audio/' + this.PARLIAMENTARIAN.PHID + '.mp3';
            }
        },
        methods: {
            playAudioPronunciation() {
                this.$nextTick(() => {
                    this.$refs.audioPronunciation.play();
                });
            },
            loadParliamentarian() {
                this.loading = true;
                const url = `individuals?$orderby=FamilyName,GivenName
                &$filter=PHID%20eq%20%27${this.PHID}%27`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.PARLIAMENTARIAN = response.data.value[0];
                        if (this.PARLIAMENTARIAN != null){
                            window.document.title = this.PARLIAMENTARIAN.DisplayName;   
                        }
                        this.loading = false;

                        try {
                            require('../../public/audio/' + this.PARLIAMENTARIAN.PHID + '.mp3');
                            this.showAudioPronunciation = true;
                        } catch (e) {
                            this.showAudioPronunciation = false;
                        }
                     });
            },
            loadTimelineData() {
                this.loadingTimeline = true;
                const url = `Parliamentarian/GetTimeline?id=${this.PHID}`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.timelineData = response.data;
                        this.loadingTimeline = false;
                    });
            },
            DownloadBiography: function () {
                let url = `${this.$store.state.URL_API}/document/biography`;
                // merge cleanRecord to record
                const biography = this.$refs.biography.FILTERED_BIOGRAPHY.map(b => ({
                    ...b,
                    biography: b.biography.map(a => ({
                        ...a,
                        record: a.cleanRecord ? a.cleanRecord : a.record
                    }))
                }));
                let biographyModel = { phid: this.PHID, displayName: this.PARLIAMENTARIAN.DisplayName, biography }

                this.pdfDownloading = true;
                axios.post(url, biographyModel, { responseType: 'arraybuffer' })
                    .then((response) => {
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            downloadUrl = window.URL.createObjectURL(blob),
                            filename = `Biography [${this.PARLIAMENTARIAN.DisplayName}].pdf`

                        let a = document.createElement("a");
                        if (typeof a.download === "undefined") {
                            window.location.href = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                        a.remove();
                    }).catch(() => { })
                    .finally(() => this.pdfDownloading = false);
            }
        }
    }
</script>

<style scoped>
    .subheadingNew {
        padding-left: 20px;
        font-size: 16px !important;
        font-weight: 400;
        cursor: pointer;
        padding-bottom: 4px;
        padding-top: 4px;
    }

        .subheadingNew > p {
            color: #ffffff;
            padding-bottom: 8px;
            padding-top: 4px;
            margin-bottom: auto;
        }

    .handbook-portraitCard_center {
        max-width: 220px;
        margin: 0 auto;
    }

    .handbook-portraitCard_tooltip {
        display: block;
        max-width: 300px;
    }


    .pronunciationBtn {
        margin-left: 1rem;
        background-color: #e3e3e3;
        border-radius: 5px;
        padding: 5px;
        border: 1px solid #d9d9d9;
    }

    .pronunciationBtn:hover  {
        background-color: #cdcdcd;
        border: 1px solid #c7c3c3;
    }

    .pronunciationBtn:hover .v-icon {
        color: black
    }

    .pronunciationBtn .v-icon {
        font-size: 20px;
    }

    @media  (max-width: 599px) {
        .v-card__actions {
            display: inline;
            padding: 8px;
        }

        .v-card__actions .v-btn {
            margin-top:5px;
        }
    }
</style>
